import React, { useCallback } from 'react';
import { Buttons, ExportTableModal } from 'components';
import { ExportIcon } from 'assets/icons';
import { useSignal, useComputed } from '@preact/signals-react';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
};

export const ExportBtn = () => {
  const isOpen$ = useSignal(false);

  const handleOpenPopup = useCallback(() => {
    isOpen$.value = true;
  }, []);

  return (
    <div style={{ marginRight: '8px' }}>
      <Buttons.QuaternaryNormal
        id='chooseExportBtn'
        icon={<ExportIcon />}
        isPressed={isOpen$.value}
        style={isOpen$.value ? btnCustomOpen : {}}
        onClick={handleOpenPopup}
      >
        Export
      </Buttons.QuaternaryNormal>
      {useComputed(
        () => isOpen$.value && <ExportTableModal isOpen$={isOpen$} title='Export .CSV' />,
      )}
    </div>
  );
};
